import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./Store";
import { DatabaseTable } from "../models/BaseTable";
import { Class, Immutable } from "../helpers/Util";
import { List } from "immutable";

export const useStoreDispatch: () => AppDispatch = useDispatch;
export const useStoreSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useTableSelector = <T extends DatabaseTable>(
  table: Class<T>,
): List<Immutable<T>> =>
  useStoreSelector((state) => {
    const tableMap = state.tables.tables.get(
      table as unknown as typeof DatabaseTable,
    );
    if (typeof tableMap === "undefined") {
      return List() as List<T>;
    }
    return tableMap.toList() as List<T>;
  });

export const useRowSelector = <T extends DatabaseTable>(
  table: Class<T>,
  pk: number,
): Immutable<T> | undefined =>
  useStoreSelector((state) => {
    const tableMap = state.tables.tables.get(
      table as unknown as typeof DatabaseTable,
    );
    if (typeof tableMap === "undefined") {
      return undefined;
    }
    return tableMap.get(pk) as T;
  });
